import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import Neoosearchlogopurple from "../../src/Images/Neoo search logo white.png";
import Neoosearchlogopurple from "../../src/Images/logo/white.png";
import Sidebar from "../Component/Sidebar";
import searchhomeprofileimg from "../../src/Images/searchhomeprofileimg.png";
import { Colorcontext } from "../Component/Colorcontext/ColorContext";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { UserLogout } from "../Redux/Slice/PostSlice";
import nophotoCamera from "../../src/Images/cameralogo.png";
import NotificationBar from "../Component/NotificationBar";
import { fetchAllNotifications, readAllNotifications } from "../Redux/Slice/NotificationSlice";

const HomeSearchheader = () => {
  const colorData = useContext(Colorcontext);
  const navigate = useNavigate();
  const location = useLocation();
  const [dropwdownnopemnmen, setDropwdownnopemnmen] = useState(false);
  const { UserProfileID } = useSelector((state) => state.app);
  const { UnreadNotificationsCount } = useSelector((state) => state.notification);
  console.log("LINE21", UserProfileID);
  const dispatch = useDispatch()

  useEffect(() => {
    // Close dropdown menu on navigation
    setDropwdownnopemnmen(false);
  }, [location]);
  const sidebaropen = () => {
    document.querySelector(".sidebardiv").style.cssText += "right: 0";
  };
  const [stickyheader, setStickyheader] = useState(false);
  function setFixed() {
    if (window.scrollY > 100) {
      setStickyheader(true);
    } else {
      setStickyheader(false);
    }
  }

  // useEffect(() => { }, []);

  window.addEventListener("scroll", setFixed);

  const handlepageclick = (e) => {
    setDropwdownnopemnmen(!dropwdownnopemnmen);
  };

  const userProfile = () => {
    UserProfileID?.memberStatus ? navigate(`/profile/${UserProfileID?.userName}`) : navigate(`/NonMemberuserprofile/${UserProfileID?.userName || "user"}`)
    // UserProfileID?.memberStatus ? navigate(`/profile/${UserProfileID?._id}`) : navigate(`/NonMemberuserprofile/${UserProfileID?.userName || "user"}`)
  };

  console.log("LOINE49", UserProfileID);

  const [showNotifibar, setshowNotifibar] = useState(false);

  const toggleNotifibar = () => {
    setshowNotifibar(!showNotifibar);
    //Call function to update read notification
    // dispatch(readAllNotifications())
  };


  const handleLogOut = () => {
    toast.success("Logout SuccessFull");
    dispatch(UserLogout())
    sessionStorage.clear();
    localStorage.clear();
    navigate("/");
  };

  const divRef = useRef(null);

  const handleClickOutside = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      console.log("Clicked outside the div!");
      setDropwdownnopemnmen(false);
    }
  };

  useEffect(() => {
    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Cleanup event listener
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // alert(1)
    showNotifibar && dispatch(fetchAllNotifications())
  }, [showNotifibar])

  return (
    <>
      {/* <section className='homesearchheadermain'> */}
      <section
        className={`homesearchheadermain ${stickyheader ? "fixed" : ""} ${colorData.color ? "hdbkpt" : ""
          }`}
      >
        <div className="cust_container">
          <div className="headerlogocnctmain">
            <Link to="/">
              <figure class="logoneeo">
                <img src={Neoosearchlogopurple} alt="..."

                />
              </figure>
            </Link>

            <div className="iconmainheader">
              {
                UserProfileID && (
                  <>
                    <div className="iconhdmin" style={{
                      position:'relative'
                    }}
                      onClick={toggleNotifibar}
                    >
                    {UnreadNotificationsCount > 0 && <div className="notification_number_circle">{UnreadNotificationsCount}</div>}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="Layer_1"
                        data-name="Layer 1"
                        viewBox="0 0 122.88 89.08"
                      >
                        <path d="M70,9.18a29.87,29.87,0,0,1,13.08,8.23A29.38,29.38,0,0,1,90.54,32.2,58.36,58.36,0,0,1,91,43.12c0,2.45-.08,4.89.1,7.22a22.47,22.47,0,0,0,3,10.12A25.4,25.4,0,0,0,102,68.3a4.35,4.35,0,0,1,1.83,2.53,4.47,4.47,0,0,1,0,2.46,4.64,4.64,0,0,1-1.33,2.09,4.43,4.43,0,0,1-2.94,1.09H75.87v0h0a14.56,14.56,0,0,1-28.85,0H23.35a4.4,4.4,0,0,1-3.05-1.19,4.55,4.55,0,0,1-1.25-4.5A4.32,4.32,0,0,1,21,68.22a24.53,24.53,0,0,0,8.39-8.84,25.3,25.3,0,0,0,2.53-12c0-1.57,0-2.46,0-3.37a62.56,62.56,0,0,1,.52-11.85A29.71,29.71,0,0,1,53.1,9.13a8.56,8.56,0,0,1,3.43-3.79,10,10,0,0,1,10,0A8.6,8.6,0,0,1,70,9.18ZM17.71,3.47a2.09,2.09,0,0,1-.62.6A32.49,32.49,0,0,0,13,7.17a28.66,28.66,0,0,0-3.37,3.54,26.28,26.28,0,0,0-2.55,3.92,23.72,23.72,0,0,0-1.7,4.22,22.88,22.88,0,0,0-.84,4.48,24.33,24.33,0,0,0,0,4.67,28.43,28.43,0,0,0,.91,4.83,34,34,0,0,0,1.78,4.88,2.11,2.11,0,0,1,.2.84,2.17,2.17,0,0,1-.14.85,2.25,2.25,0,0,1-.42.7,2.16,2.16,0,0,1-.61.47,1.07,1.07,0,0,1-.22.1,2,2,0,0,1-.79.16,2,2,0,0,1-.81-.14,2.18,2.18,0,0,1-.7-.42,2.42,2.42,0,0,1-.49-.64l-.07-.15a38.61,38.61,0,0,1-2-5.57,32.61,32.61,0,0,1-1-5.54,28.68,28.68,0,0,1,0-5.48,28.17,28.17,0,0,1,1-5.27v0a27.36,27.36,0,0,1,2-5A29.49,29.49,0,0,1,6.11,8,32.57,32.57,0,0,1,10,3.9,36.84,36.84,0,0,1,14.66.37l0,0A2.25,2.25,0,0,1,15.51,0a2.51,2.51,0,0,1,.82,0h0a2.26,2.26,0,0,1,.78.34,2.09,2.09,0,0,1,.6.62h0a2.12,2.12,0,0,1,.31.81,2.26,2.26,0,0,1,0,.86,2.28,2.28,0,0,1-.35.78ZM29.3,13.34l0,0a26.2,26.2,0,0,0-3,2.15,19.35,19.35,0,0,0-2.36,2.34l0,0a15.64,15.64,0,0,0-1.73,2.54A12.89,12.89,0,0,0,21,23.13,13.23,13.23,0,0,0,20.54,26a16,16,0,0,0,.15,3.07,19.18,19.18,0,0,0,.78,3.28v0a24,24,0,0,0,1.43,3.44,2.28,2.28,0,0,1,.22.84,2.06,2.06,0,0,1-.1.82v0a2.22,2.22,0,0,1-.4.72,2.29,2.29,0,0,1-.64.52l-.07,0a2.28,2.28,0,0,1-.83.22,2.13,2.13,0,0,1-.83-.1h0a2.22,2.22,0,0,1-.72-.4,2,2,0,0,1-.52-.64l0-.07a29.85,29.85,0,0,1-1.71-4.15,22.93,22.93,0,0,1-.94-4,19.36,19.36,0,0,1-.16-3.93,17.29,17.29,0,0,1,.64-3.76,17.65,17.65,0,0,1,1.43-3.53,19.37,19.37,0,0,1,2.21-3.27,23.81,23.81,0,0,1,2.92-2.94,31.3,31.3,0,0,1,3.6-2.59l0,0a2.1,2.1,0,0,1,.81-.3,2.07,2.07,0,0,1,.86,0,2.2,2.2,0,0,1,.75.33,2.1,2.1,0,0,1,.57.58l.08.13a2.14,2.14,0,0,1,.28.79A2.27,2.27,0,0,1,30,12.72a2.25,2.25,0,0,1-.58.57l-.07.05Zm76.49-9.27a2.09,2.09,0,0,1-.62-.6,2.28,2.28,0,0,1-.35-.78,2.26,2.26,0,0,1,0-.86,2.12,2.12,0,0,1,.31-.81h0a2.09,2.09,0,0,1,.6-.62,2.26,2.26,0,0,1,.78-.34h0a2.51,2.51,0,0,1,.82,0,2.25,2.25,0,0,1,.81.32l0,0a36.84,36.84,0,0,1,4.67,3.53A32.57,32.57,0,0,1,116.77,8a29.49,29.49,0,0,1,3,4.59,27.36,27.36,0,0,1,2,5v0a28.17,28.17,0,0,1,1,5.27,29.53,29.53,0,0,1,0,5.48,32.61,32.61,0,0,1-1,5.54,38.61,38.61,0,0,1-2,5.57l-.07.15a2.42,2.42,0,0,1-.49.64,2.18,2.18,0,0,1-.7.42,2.21,2.21,0,0,1-1.6,0l-.22-.1a2.16,2.16,0,0,1-.61-.47,2.25,2.25,0,0,1-.42-.7,2.17,2.17,0,0,1-.14-.85,2.11,2.11,0,0,1,.2-.84,34,34,0,0,0,1.78-4.88,28.43,28.43,0,0,0,.91-4.83,24.33,24.33,0,0,0,0-4.67,22.88,22.88,0,0,0-.84-4.48,23.72,23.72,0,0,0-1.7-4.22,25.58,25.58,0,0,0-2.56-3.92,27.84,27.84,0,0,0-3.36-3.54,32.49,32.49,0,0,0-4.11-3.1ZM93.62,13.36l-.11-.07a2.25,2.25,0,0,1-.58-.57,2.27,2.27,0,0,1-.37-1.58,2.14,2.14,0,0,1,.28-.79l.08-.13a2.1,2.1,0,0,1,.57-.58,2.24,2.24,0,0,1,.74-.33,2.24,2.24,0,0,1,1.68.27l0,0a31.3,31.3,0,0,1,3.6,2.59,23.81,23.81,0,0,1,2.92,2.94,19.37,19.37,0,0,1,2.21,3.27,17.65,17.65,0,0,1,1.43,3.53,17.92,17.92,0,0,1,.64,3.76,19.36,19.36,0,0,1-.16,3.93,22.93,22.93,0,0,1-.94,4,29.85,29.85,0,0,1-1.71,4.15l0,.07a2,2,0,0,1-.52.64,2.22,2.22,0,0,1-.72.4h0a2.13,2.13,0,0,1-.83.1,2.28,2.28,0,0,1-.83-.22l-.07,0a2.29,2.29,0,0,1-.64-.52,2.22,2.22,0,0,1-.4-.72v0a2.06,2.06,0,0,1-.1-.82,2.18,2.18,0,0,1,.22-.83,24.55,24.55,0,0,0,1.43-3.45v0a19.18,19.18,0,0,0,.78-3.28,16,16,0,0,0,.15-3.07,13.23,13.23,0,0,0-.49-2.89,12.89,12.89,0,0,0-1.11-2.71A15.64,15.64,0,0,0,99,17.88l0,0a19.35,19.35,0,0,0-2.36-2.34,26.2,26.2,0,0,0-3-2.15Zm-14,7.26a25.15,25.15,0,0,0-12-7.22A2.36,2.36,0,0,1,66,11.77a4,4,0,0,0-1.84-2.38,5.2,5.2,0,0,0-2.6-.68A5,5,0,0,0,59,9.38a4,4,0,0,0-1.8,2.36,2.35,2.35,0,0,1-1.71,1.64A25,25,0,0,0,37,33,59.78,59.78,0,0,0,36.56,44c0,1.44,0,2.85,0,3.44a29.83,29.83,0,0,1-3.07,14.15,28.69,28.69,0,0,1-9.38,10.19H98.73a29.34,29.34,0,0,1-8.64-8.86,27.08,27.08,0,0,1-3.67-12.21c-.19-2.41-.14-5-.1-7.64a54.63,54.63,0,0,0-.43-10,24.7,24.7,0,0,0-6.25-12.39Z" />
                      </svg>
                      <span className="headermenuname">Notification</span>
                    </div>
                  </>
                )
              }


              <div className="iconhdmin" onClick={sidebaropen}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                  <path d="M 0 9 L 0 11 L 50 11 L 50 9 Z M 0 24 L 0 26 L 50 26 L 50 24 Z M 0 39 L 0 41 L 50 41 L 50 39 Z"></path>
                </svg>
                <span className="headermenuname">Menu</span>
              </div>

              <div className="imgprfls"
                onClick={handlepageclick}
              >
                {UserProfileID ? (
                  <div className="prflimg"
                  // onClick={userProfile}
                  >
                    {/* <img src={searchhomeprofileimg} alt="img" /> */}
                    <img src={UserProfileID?.profilePhoto || searchhomeprofileimg} alt="img" />
                  </div>
                ) : (
                  <div className="prflimg"
                  // onClick={userProfile}
                  >
                    <img src={searchhomeprofileimg} alt="img" />
                  </div>
                )}
                <div className="iconarrw" onClick={handlepageclick}>
                  <i className="fa-solid fa-chevron-down"></i>
                </div>
                {dropwdownnopemnmen && (
                  <div className="userDrop" ref={divRef}>
                    <ul className="userMenu">
                      {
                        UserProfileID && (
                          <>
                            {/* <li>
                              <Link to="">
                                <i className="fa-solid fa-user  mr-2"></i> Go to my Neoo page
                              </Link>
                            </li> */}
                            {
                              UserProfileID.memberStatus ? (
                                <>
                                  <li>
                                    <Link to={`/profile/${UserProfileID?.userName}`}
                                      className="profileLink"
                                    >
                                      <div className="prflimg">
                                        <img src={UserProfileID?.profilePhoto || searchhomeprofileimg} alt="img" />
                                      </div> <span className="linkText">My profile</span>
                                    </Link>
                                  </li>
                                </>
                              ) : (
                                <>
                                  <li>
                                    <Link to={`/NonMemberuserprofile/${UserProfileID?.userName || "user"}`}
                                      className="profileLink"
                                    >
                                      <div className="prflimg">
                                        <img src={UserProfileID?.profilePhoto || searchhomeprofileimg} alt="img" />
                                      </div> <span className="linkText">My profile</span>
                                    </Link>
                                  </li>
                                </>
                              )
                            }

                            {
                              UserProfileID.businessStatus &&
                              <li>
                                <Link
                                  // to={`/member/dashboard`}
                                  to={`/businesspage/${UserProfileID?.companyName.toLowerCase().replace(/\s+/g, "_")}`}
                                  className="profileLink"
                                >
                                  <div className="prflimg">
                                    <img src={UserProfileID?.businessProfilePic || nophotoCamera} alt="img" />
                                  </div> <span className="linkText">My page</span>
                                </Link>
                              </li>
                            }

                          </>
                        )
                      }


                      {!UserProfileID && (
                        <li>
                          <Link to="/user-login">
                            <i className="fa-regular fa-circle-right mr-2"></i>
                            Log In
                          </Link>
                        </li>
                      )}
                      {
                        !UserProfileID ? (
                          <>
                            <li>
                              <Link to="/priceandplan">
                                <i className="fa-solid fa-user-plus mr-2"></i> List your business
                              </Link>
                            </li>
                          </>
                        ) : (
                          <>
                            {
                              !UserProfileID.businessStatus &&
                              <li>
                                {/* <Link to="/priceandplan"> */}
                                {/* <Link to="/signup"> */}
                                <Link to="/businessdirectory">
                                  <i className="fa-solid fa-user-plus mr-2"></i> List your business
                                </Link>
                              </li>
                            }

                          </>
                        )
                      }


                      {
                        UserProfileID && (
                          <>
                            <li>
                              <Link to="/masterdashbord">
                                <i className="fa-solid fa-chart-line mr-2"></i> Master Dashboard
                              </Link>
                            </li>
                            <li>
                              <Link to="/" onClick={handleLogOut}>
                                <i className="fa-solid fa-arrow-right-from-bracket mr-2"></i>
                                Logout
                              </Link>
                            </li>
                          </>
                        )
                      }




                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Sidebar />
        {/****NotificationBar*****/}
        <NotificationBar show={showNotifibar} closeNotifiBar={toggleNotifibar} />
      </section>
    </>
  );
};

export default HomeSearchheader;
